<template>
	<div style="width:1000px; height:800px;" v-on:keyup.esc="close()">
		<table class="list_tbl">
			<thead>
				<tr>
					<th width="10%">{{ headers.class }}</th>
					<th>Name</th>
					<th width="10%">Color</th>
					<th width="7%">Price</th>
					<th width="7%" v-if="session_user.company_id == 'newjigu' && invoice.status_code == 'O'">Req. Price</th>
					<th width="6%">{{ invoice.invoice_type == 'R' ? 'Return' : 'Order' }}</th>
					<th width="7%">Amount</th>
					<th width="6%">{{ invoice.invoice_type == 'R' ? 'Conf.' : 'Shipped' }}</th>
					<th width="7%">Amount</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in items" v-bind:key="item.invoice_item_no">
					<td class="al_left">
						<template v-if="index == 0 || (index > 0 && item.class_code != items[index - 1].class_code)">
							{{ item.class_code }}
						</template>
					</td>

					<td class="al_left">
						<b v-if="item.active_yn == 'N'"><font color="red">!!</font></b
						>{{ item.name }}
					</td>
					<td class="al_left">{{ item.color_code }}</td>
					<td class="al_right">{{ item.unit_price | toCurrency }}</td>
					<td class="al_right" v-if="session_user.company_id == 'newjigu' && invoice.status_code == 'O'">{{ item.r_price | toCurrency }}</td>
					<td class="al_right">{{ item.quantity_abs | commaSeparated }}</td>
					<td class="al_right">{{ item.amount | toCurrency }}</td>
					<td class="al_right">{{ item.shipped_quantity_abs | commaSeparated }}</td>
					<td class="al_right">{{ item.shipped_amount | toCurrency }}</td>
				</tr>
			</tbody>
		</table>

		<div class="popup_bottom">
			<a href="javascript:;" @click="close()" class="gray_bt">Close</a>
		</div>
	</div>
</template>

<script>
// import '@/assets/css/table_box.css';
import { apiSelectInvoiceItemList } from '@/api/sales/invoice.js';
// import { apiSelectUserList } from '@/api/basicinfo/user';
// import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
// import CodeSelect from '@/components/common/CodeSelect';
// import PartnerSelect from '@/components/common/PartnerSelect';
// import { daysAgo, today } from '@/utils/date.js';

export default {
	data: function() {
		return {
			// invoice_type: 'S',
			// status_code: null,
			// //status_code: 'P',
			// so_date_from: daysAgo(3),
			// so_date_to: today(),
			// sales_group_code: null,
			// ship_to_code: null,
			// bill_to_code: null,
			// state: null,
			// keyword: null,
			// salesGroups: [],
			items: [],
			// saleStatusCodes: [],
			// invoices: [],
			// wh_staff_id: null,
			// wh_staff_list: [],
		};
	},
	props: {
		invoice: Object,
	},
	computed: {
		session_user: {
			get() {
				return this.$session.get('user');
			},
		},
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
	},
	components: {
		// CustomDatePicker,
		// CodeSelect,
		// PartnerSelect,
	},
	methods: {
		// async getWhStaffList() {
		// 	let { data } = await apiSelectUserList({
		// 		company_id: this.session_user.company_id,
		// 		active_yn: 'Y',
		// 		user_type: 'whstaff',
		// 		sort_key: 'user_name',
		// 	});

		// 	this.wh_staff_list = data.userList;
		// },
		// selectInvoice(invoice) {
		// 	if (this.link) {
		// 		let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
		// 		window.open(routeData.href, 'herp_invoice');
		// 	}
		// },
		// selectSo(invoice) {
		// 	if (this.link) {
		// 		let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
		// 		window.open(routeData.href, 'herp_so');
		// 	}
		// },
		// postStatusLoading() {
		// 	if (this.initialStatusCode || this.initialShipToCode) {
		// 		this.$nextTick(() => {
		// 			this.search();
		// 		});
		// 	}
		// },
		// setShipTo(partner) {
		// 	this.ship_to_code = partner.code;
		// 	this.search();
		// },
		// setBillTo(partner) {
		// 	this.bill_to_co = partner.code;
		// 	this.search();
		// },

		async init() {
			var param = {
				invoice_no: this.invoice.invoice_no,
			};

			//			if (this.invoice.invoice_type == 'R') param.invoiced_item_only = true;

			const { data } = await apiSelectInvoiceItemList(param);
			this.items = data.invoiceItemList;
		},

		close() {
			this.$emit('close');
		},
	},
	created() {
		//console.log(this.invoice);
		this.init();
		//this.selectPartners();
		//this.item = _.cloneDeep(this.selectedItem);
		// if (this.initialKeyword) {
		// 	this.keyword = this.initialKeyword;
		// 	this.selectSalesOrders();
		// }
	},
};
</script>

<style></style>
